// extracted by mini-css-extract-plugin
export var dropdownContainer = "_51-5";
export var imageContainer = "_51-4";
export var metricsGrid = "_51-2";
export var productDetailContainer = "_51-1";
export var productListContainer = "_51-0";
export var subscriberTableContainer = "_51-3";